import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { lightable, lighted } from 'owa-lightning-v2';
import { toggleCharm } from 'owa-header-store';
var GetStartedCallout = /** @class */ (function (_super) {
    tslib_1.__extends(GetStartedCallout, _super);
    function GetStartedCallout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GetStartedCallout.prototype.render = function () {
        toggleCharm(7 /* GetStartedCharm */);
        lighted(this.props.lid);
        return null;
    };
    GetStartedCallout = tslib_1.__decorate([
        observer,
        lightable
    ], GetStartedCallout);
    return GetStartedCallout;
}(React.Component));
export default GetStartedCallout;
//# sourceMappingURL=GetStartedCallout.js.map